import React, { useEffect, useState } from 'react';
import { BrowserRouter, Redirect, Route, Switch, useHistory } from 'react-router-dom';
import PrivateRoute from './auth/PrivateRoute';
import Login from './pages/login';
import "./App.css"
import { getIsUserLoggedIn, getUserAccessData, setIsUserLoggedIn, setToken, setUserAccessData, setUserDetails } from './utilities/sessionHelper';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { fetchUserData, setUser } from './store/reducers/userSlice';
import { notification } from 'antd';
import { getUserRole, handleLogout } from './utilities/CommonHelper';
function App() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(getIsUserLoggedIn());


  useEffect(() => {
    const axiosConfig = {
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
      withCredentials: true
    };

    if (!getIsUserLoggedIn()) {
      axios.get(`/indegenessoconnect/public/userValidation`, axiosConfig).then((response: any) => {

        if (response.data.status === 'OK') {
          setToken(response.data.data.token);
          setUserDetails(response.data.data);
          dispatch(fetchUserData()).then((response: any) => {
            if(typeof(response.payload)!=='string'){
              setUserAccessData(response.payload.data);
              setIsUserLoggedIn(true);
              setIsAuthenticated(true);
              if (window.location.pathname === '/login') {
                window.location.pathname=getLandingPage(getUserRole(getUserAccessData()?.roleAccessMap));
              }
            }
            else{
              notification.error({
                message: 'Error',
                description: response.payload,
              })
              if (window.location.pathname === '/login') {
                history.push(getLandingPage(getUserRole(getUserAccessData()?.roleAccessMap)));
              }
            }

            
          });
        } else {
          handleLogout();
        }
      }).catch((error: any) => {
        console.log('error', error);
        handleLogout();
      });
    }
  }, [isAuthenticated]);

  const getLandingPage = (role: string | null) => {
    if (role) {
      if (role === 'Admin') {
        return '/userDashboard';
      }else {
        return '/orderDashboard';
      }
    } else {
      return '/requestAccess';
    }
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route path="/login" render={() => (<Login />)} />

          <PrivateRoute
            path="/userDashboard"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />
          {/* <Route path="/orderDashboard" render={() => (<OrderDashboard />)} /> */}
          {/* <PrivateRoute
            path="/orderDashboard"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          /> */}
          <PrivateRoute
            path="/orderDashboard"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />

          <PrivateRoute
            path="/poDashboard"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />

          <PrivateRoute
            path="/requestAccess"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />

          <PrivateRoute
            path="/rmPendingRequest"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
            fallbackPath="/login"
          />
          <PrivateRoute
            path="/obo-report"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />
          <PrivateRoute
            path="/obo-report-old"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />
          <PrivateRoute
            path="/sow-ageing-report"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />
          <PrivateRoute
            path="/sow-revenue-report"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />
          <PrivateRoute
            path="/consolidated-revenue-forecasting"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />
          <PrivateRoute
            path="/revenue-forecasting-poc"
            role={getUserRole(getUserAccessData()?.roleAccessMap)}
            isAuthenticated={isAuthenticated}
          />

          <Redirect
            from="/"
            to={getLandingPage(getUserRole(getUserAccessData()?.roleAccessMap))}
          />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
